<template>
  <div class="layout" id="myComponentDiv">
    <!-- Título del módulo -->
    <div class="box-titulo">RECARGAS DE CLIENTES</div>

    <!-- Contenedor principal -->
    <div class="box-container">
      <!-- Filtros -->
      <div class="box-filtres">
        <table width="100%">
          <tbody>
            <!-- Fila de etiquetas -->
            <tr>
              <td width="300px">CLIENTE</td>
              <td width="200px">FLOTA</td>
              <td width="100px">FECHA</td>
              <td width="100px">VALOR RECARGA</td>
              <td width="1px"></td>
            </tr>

            <!-- Fila de inputs -->
            <tr>
              <!-- Selector de cliente -->
              <td>
                <Select2
                  v-model="cliente_unique"
                  :options="clientes"
                  @select="onSelectCliente($event)"
                  placeholder="Seleccione un cliente"
                />
              </td>

              <!-- Selector de flota (deshabilitado hasta seleccionar cliente) -->
              <td>
                <Select2
                  v-model="flota_unique"
                  :options="flotas"
                  @select="onSelectFlota($event)"
                  :disabled="!cliente_unique"
                  placeholder="Seleccione una flota"
                />
              </td>

              <!-- Input de fecha -->
              <td>
                <input
                  class="form-control center"
                  type="text"
                  datatype="fecha"
                  autocomplete="off"
                  id="fecha_recarga"
                  readonly="true"
                />
              </td>

              <!-- Input de valor de recarga -->
              <td>
                <input
                  v-model="valor_recarga"
                  class="form-control"
                  style="text-transform: uppercase"
                  placeholder="0"
                />
              </td>
              <td></td>
            </tr>

            <!-- Resumen de valores -->
            <tr>
              <td colspan="4" class="text-right">
                <table class="table tablet-borded">
                  <tbody>
                    <tr>
                      <td width="80%">CONSUMO</td>
                      <td class="b">{{ GLOBAL.FORMATO_MONEY(consumo) }}</td>
                    </tr>
                    <tr>
                      <td>SALDO</td>
                      <td class="b">{{ GLOBAL.FORMATO_MONEY(saldo) }}</td>
                    </tr>
                    <tr>
                      <td>RECARGA</td>
                      <td class="b">
                        {{ GLOBAL.FORMATO_MONEY(valor_recarga) }}
                      </td>
                    </tr>
                    <tr>
                      <td>NUEVO SALDO</td>
                      <td class="b">
                        {{
                          GLOBAL.FORMATO_MONEY(
                            saldo + parseFloat(valor_recarga || 0)
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <!-- Botón de guardar -->
            <tr>
              <td colspan="4" class="text-right">
                <hr />
                <div style="height: 30px; color: red">
                  {{ mensaje }}
                </div>
                <button
                  class="btn btn-info"
                  @click="guardarRecarga"
                  :disabled="!flota_unique || !cliente_unique || loading"
                >
                  <i class="fa-solid fa-save"></i> Guardar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Tabla de recargas -->
      <div>
        <table
          id="table1"
          width="100%"
          class="display nowrap"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th width="100px">Fecha</th>
              <th width="100px">Consecutivo</th>
              <th width="150px">Cliente</th>
              <th width="150px">Flota</th>
              <th width="100px">Recarga</th>
              <th width="100px">Estado</th>
              <th width="100px">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "../Vehiculos/VehiculoService.js";
import ReporteService from "../../service/ReporteService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";

export default {
  components: { Select2 },
  data() {
    return {
      GLOBAL,
      person: null,
      vehiculo: null,
      tercero: null,
      flota: null,
      valor_recarga: 0,
      fecha_recarga: null,
      loading: false,
      consumo: 0,
      saldo: 0,
      disableBotonGuardar: true,
      mensaje: "",
      reporte: [],
      acuerdo: null,
      vehiculoService: null,
      clienteService: null,
      clientes: [],
      cliente: null,
      cliente_unique: null,
      credito: {},
      flotas: [], // Lista de flotas del cliente seleccionado
      flota_unique: null, // ID de la flota seleccionada
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.vehiculoService = new VehiculoService();
    this.clienteService = new ClienteService();

    this.credito = {};
    this.credito.flota = "";

    this.mensaje = "";
  },
  mounted() {
    // Inicializar el datepicker para la fecha
    $("input[datatype='fecha']").datetimepicker({
      onSelect: (dateText) => {
        this.actualizaComponente(dateText);
      },
    });

    // Cargar datos iniciales
    this.getListaCliente();
    this.getListaRecargas();
  },
  methods: {
    // Actualizar componente con la fecha seleccionada
    actualizaComponente(selected) {
      this.fecha_recarga = selected;

      if (this.cliente && this.cliente._id) {
        this.clienteService
          .getSaldoCliente(this.person, this.cliente._id, this.fecha_recarga)
          .then((response) => {
            try {
              this.consumo = parseFloat(response.consumo) || 0;
              this.saldo = parseFloat(response.saldo) || 0;
            } catch (error) {
              this.consumo = 0;
              this.saldo = 0;
            }
          });
      }
    },

    // Manejar la selección de cliente
    onSelectCliente({ id, text }) {
      this.cliente = this.clientes.find(c => c.id == id);
      this.cliente._id = this.cliente.id;
      this.flota_unique = null; // Resetear flota al cambiar de cliente
      this.flotas = []; // Limpiar flotas anteriores
      this.getFlotasDelCliente(id); // Cargar flotas del cliente seleccionado
    },

    // Obtener las flotas de un cliente
    getFlotasDelCliente(clienteId) {
      this.loading = true;
      this.vehiculoService
        .getFlotasConVehiculos(this.person, { _id: clienteId })
        .then((data) => {
          this.flotas = data.map(flota => ({
            id: flota.uniqueid,
            text: flota.descripcion,
            ...flota
          }));
        })
        .catch((error) => {
          console.error("Error al cargar flotas:", error);
          this.flotas = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Manejar la selección de flota
    onSelectFlota({ id, text }) {
      this.flota = this.flotas.find(f => f.id == id);
    },

    // Obtener la lista de clientes
    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          this.clientes = data.map(cliente => ({
            id: cliente._id,
            text: cliente.nombres,
            nit: cliente.identificacion,
            nombres: cliente.nombres,
          }));
        })
        .catch((error) => {
          console.error("Error al cargar clientes:", error);
          this.clientes = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Guardar la recarga
    guardarRecarga() {
      this.mensaje = "";

      // Validaciones
      if (!this.cliente_unique) {
        this.mensaje = "Seleccione un cliente";
        return;
      }

      if (!this.flota_unique) {
        this.mensaje = "Seleccione una flota";
        return;
      }

      if (!this.fecha_recarga) {
        this.mensaje = "Verifique la fecha";
        return;
      }

      if (!this.valor_recarga || this.valor_recarga <= 0) {
        this.mensaje = "Ingrese un valor de recarga válido";
        return;
      }

      // Preparar la solicitud
      this.loading = true;
      var request = {
        tercero_id: this.cliente._id,
        tercero_nit: this.cliente.nit,
        tercero_nombre: this.cliente.nombres,
        flota_id: this.flota.id, // ID de la flota seleccionada
        flota_descripcion: this.flota.text, // Descripción de la flota
        fecha_recarga: this.fecha_recarga,
        venta_total: parseFloat(this.valor_recarga),
      };

      // Enviar la solicitud al backend
      this.clienteService
        .agregarRecargarCliente(this.person, request)
        .then((response) => {
          // Limpiar campos después de guardar
          this.valor_recarga = 0;
          this.consumo = 0;
          this.saldo = 0;
          this.cliente_unique = null;
          this.flota_unique = null;
          this.cliente = null;
          this.flota = null;
          this.fecha_recarga = "";
          $("#fecha_recarga").val("");

          // Actualizar la lista de recargas
          this.getListaRecargas();
          this.mensaje = "Recarga guardada correctamente";
        })
        .catch((error) => {
          console.error("Error al guardar la recarga:", error);
          this.mensaje = "Error al guardar la recarga. Intente nuevamente.";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Actualizar una recarga
    updateRecarga(data) {
      this.loading = true;
      this.clienteService
        .updateRecarga(this.person, data)
        .then((response) => {
          this.valor_recarga = 0;
          this.consumo = 0;
          this.saldo = 0;
          this.getListaRecargas();
          this.mensaje = "Recarga actualizada correctamente";
        })
        .catch((error) => {
          console.error("Error al actualizar la recarga:", error);
          this.mensaje = "Error al actualizar la recarga. Intente nuevamente.";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Obtener la lista de recargas
    getListaRecargas() {
      this.reporte = [];
      this.loading = true;
      this.clienteService
        .getRecargarCliente(this.person)
        .then((response) => {
          this.reporte = response;
        })
        .then(() => {
          // Inicializar DataTable
          try {
            $("#table1").DataTable().destroy();
          } catch (error) {}

          var vm = this;
          $("#table1").DataTable({
            data: this.reporte,
            columns: [
              { data: "fecha" },
              {
                render: function (data, type, row) {
                  return row.prefijo + "-" + row.consecutivo;
                },
              },
              { data: "tercero_nombre" },
              {
                data: "flota_descripcion", // Mostrar la descripción de la flota
                defaultContent: "N/A"
              },
              {
                class: "text-right",
                render: function (data, type, row) {
                  return GLOBAL.FORMATO_MONEY(row.venta_total);
                },
              },
              {
                class: "text-center",
                render: function (data, type, row) {
                  return row.estado == "A" ? "ACTIVO" : "ANULADO";
                },
              },
              {
                class: "text-center",
                render: function (data, type, row) {
                  return "";
                },
              },
            ],
            createdRow: function (row, data) {
              var deleteBtn = $(
                "<button class='btn btn-sm btn-warning'><i class='fa-regular fa-trash-can'></i></button>"
              );
              if (data.estado == "A") {
                $(deleteBtn).on("click", function () {
                  vm.updateRecarga(data);
                });
              } else {
                deleteBtn = $(
                  "<button disabled class='btn btn-sm btn-secondary'><i class='fa-regular fa-trash-can'></i></button>"
                );
              }
              $("td", row).eq(6).append(deleteBtn);
            },
            dom:
              "<'row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
              "<'row'<'col-sm-12'tr>>" +
              "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            buttons: [
              {
                extend: "copyHtml5",
                text: '<i class="fa-regular fa-clipboard"></i>',
                titleAttr: "Copiar",
              },
              {
                extend: "excelHtml5",
                text: '<i class="fa-regular fa-file-excel"></i>',
                titleAttr: "Exportar a Excel",
              },
              {
                extend: "csvHtml5",
                text: '<i class="fa-solid fa-file-csv"></i>',
                titleAttr: "Exportar a CSV",
              },
              {
                extend: "pdfHtml5",
                text: '<i class="fa-regular fa-file-pdf"></i>',
                titleAttr: "Exportar a PDF",
              },
            ],
            responsive: true,
            scrollX: true,
            lengthMenu: [
              [10, 20, 50, -1],
              [10, 20, 50, "Todos"],
            ],
            language: {
              url: "plugins/Spanish.json",
            },
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error al cargar recargas:", error);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
/* Estilos para el contenedor principal */
.layout {
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* Estilos para el título */
.box-titulo {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  text-align: center;
}

/* Estilos para el contenedor de filtros */
.box-container {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
}

/* Estilos para la tabla de filtros */
.box-filtres table {
  width: 100%;
  border-collapse: collapse;
}

.box-filtres td {
  padding: 8px;
  vertical-align: middle;
}

/* Estilos para los inputs y selects */
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-control.center {
  text-align: center;
}

/* Estilos para el resumen de valores */
.tablet-borded {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 10px;
}

.tablet-borded td {
  padding: 5px 10px;
  border: none;
}

.tablet-borded .b {
  font-weight: bold;
  text-align: right;
}

/* Estilos para los botones */
.btn {
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}

.btn-info {
  background-color: #17a2b8;
  color: white;
}

.btn-info:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Estilos para la tabla de recargas */
#table1 {
  margin-top: 20px;
  border-collapse: collapse;
  width: 100%;
}

#table1 th {
  background-color: #f1f1f1;
  padding: 10px;
  text-align: center;
  font-weight: bold;
}

#table1 td {
  padding: 8px;
  text-align: center;
}

/* Estilos para los mensajes de error */
.text-red {
  color: red;
  font-size: 14px;
}

/* Estilos para el loading */
.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #17a2b8;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>